export const GET_CURRENT_EXPERIENCE = "GET_CURRENT_EXPERIENCE";
export const RESET_CURRENT_EXPERIENCE = "RESET_CURRENT_EXPERIENCE";
export const SET_CURRENT_EXPERIENCE_REQUEST_STATUS = "SET_CURRENT_EXPERIENCE_REQUEST_STATUS";
export const UPDATE_EXPERIENCE_ACTIVITY = "UPDATE_EXPERIENCE_ACTIVITY";
export const UPDATE_CURRENT_EXPERIENCE = "UPDATE_CURRENT_EXPERIENCE";
